import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, IconButton, useMediaQuery } from "@mui/material";
import "./style.scss";
import { Add, FilterAltOff } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@application/store/useStore";
import { enableDisableSubGoalAsync, } from "@application/features/sub-goal/subGoalThunk";
import WNSwitch from "@ui/components/wn-switch";
import { addWarningNotification } from "@application/features/common/notificationSlice";
import { DataGrid, } from "@mui/x-data-grid";
import { AppConsts } from "@application/common/constants/app-consts";
import WnNoRecordFound from "@ui/components/wn-no-record";
import { getSubGoalsByGoalIdAsync } from "@application/features/goal/goalThunk";
import GoBack from "@ui/components/wn-go-back";
import { validateModulePermission } from "@application/common/helpers/role-claims-helper";
import { Module } from "@application/common/enums/modules";
import { PermissionType } from "@application/common/enums/permission-type";
import { translate } from "@application/common/helpers/translate";
import { setGoalSubGoalFilterModel } from "@application/features/goal/goalSlice";
import { resetFilter } from "@application/features/common/filterResetSlice";
const SubGoalsList = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { goalId } = useParams();
    const { loggedInUserRolePermission } = useAppSelector((state) => state.rolePermission);
    const modulePermissions = loggedInUserRolePermission &&
        validateModulePermission(loggedInUserRolePermission, Module[Module["Sub-Goals"]]);
    const hasCreatePermission = modulePermissions
        ? !!modulePermissions[PermissionType[PermissionType.createPermission]]
        : false;
    const hasEditPermission = modulePermissions
        ? !!modulePermissions[PermissionType[PermissionType.editPermission]]
        : false;
    useEffect(() => {
        if (goalId) {
            dispatch(getSubGoalsByGoalIdAsync(goalId));
        }
    }, [dispatch, goalId]);
    useEffect(() => {
        dispatch(resetFilter("goals"));
    }, [dispatch]);
    const onEnableDisable = ($event, id, subGoal) => {
        if ($event) {
            if (!subGoal.goal.isActive) {
                dispatch(addWarningNotification(translate("validations.subGoals.activateMainGoal")));
                return;
            }
        }
        dispatch(enableDisableSubGoalAsync({ id: id, status: $event })).then((res) => {
            if (res.payload === true) {
                if (goalId) {
                    dispatch(getSubGoalsByGoalIdAsync(goalId));
                }
            }
        });
    };
    const { subGoalList, goalSubGoalFilterModel, status } = useAppSelector((state) => state.goal);
    const onDetailsClick = (subGoal) => {
        navigate(`/admin/sub-goals/${subGoal.id}`);
    };
    const isSmall = useMediaQuery("(min-width:100px) and (max-width:1200px)");
    const columns = [
        {
            field: "name",
            flex: 1,
            headerName: translate("subGoals.subGoalName").toUpperCase(),
            sortable: true,
            minWidth: isSmall ? 180 : undefined,
            hideable: false,
        },
        {
            field: "goal",
            flex: 1,
            headerName: translate("subGoals.mainGoal").toUpperCase(),
            sortable: true,
            minWidth: isSmall ? 180 : undefined,
            valueGetter: (params) => `${params.row.goal.name}`,
        },
        {
            field: "totalCourses",
            headerName: translate("subGoals.currentCourses").toUpperCase(),
            sortable: true,
            flex: 1,
            minWidth: isSmall ? 180 : undefined,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "isActive",
            headerName: translate("common.active").toUpperCase(),
            sortable: false,
            flex: 1,
            minWidth: isSmall ? 180 : undefined,
            hideable: false,
            filterable: false,
            hideSortIcons: true,
            align: "center",
            headerAlign: "center",
            cellClassName: "tableSwitchAlignCenter",
            renderCell: (params) => (_jsx(WNSwitch, { checked: params.row.isActive, onChange: ($event) => onEnableDisable($event, params.row.id, params.row) }, params.row.id)),
        },
        {
            field: "",
            flex: 1,
            headerName: translate("common.actions").toUpperCase(),
            sortable: false,
            hideable: false,
            filterable: false,
            hideSortIcons: true,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => (_jsx(Button, { size: "small", className: "Button", sx: { fontSize: "14px" }, onClick: () => onDetailsClick(params.row), children: translate("cta.details") })),
        },
    ];
    const onFilterModelChange = (model) => dispatch(setGoalSubGoalFilterModel(model));
    const onClearFilterModel = () => dispatch(setGoalSubGoalFilterModel({ items: [] }));
    const isxs = useMediaQuery("(min-width:100px) and (max-width:750px)");
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { sx: { display: "flex" }, justifyContent: "space-between", alignItems: "center", children: [_jsx(Box, { sx: { display: "flex" }, gap: "4", alignItems: "center", children: _jsx(GoBack, { title: "Sub-Goals" }) }), _jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [isxs ? (_jsx(IconButton, { size: "medium", onClick: onClearFilterModel, children: _jsx(FilterAltOff, { fontSize: "medium" }) })) : (_jsx(Button, { className: "Button", variant: "outlined", disableElevation: true, color: "primary", onClick: onClearFilterModel, startIcon: _jsx(FilterAltOff, {}), children: "Clear Filter" })), hasCreatePermission &&
                                (isxs ? (_jsx(IconButton, { size: "medium", onClick: () => navigate("/admin/sub-goals/add"), children: _jsx(Add, { color: "primary", fontSize: "medium" }) })) : (_jsx(Button, { className: "Button", variant: "contained", disableElevation: true, color: "primary", onClick: () => navigate("/admin/sub-goals/add"), startIcon: _jsx(Add, {}), children: translate("cta.createNew") })))] })] }), _jsx(Box, { sx: {
                    marginTop: "1rem",
                    borderRadius: "12px",
                    backgroundColor: "#fff",
                    padding: "1rem",
                }, children: _jsx("div", { style: { width: "100%" }, children: _jsx(DataGrid, { componentsProps: { filterPanel: { sx: { maxWidth: "85vw" } } }, autoHeight: true, rows: subGoalList ?? [], columns: columns, filterModel: goalSubGoalFilterModel, onFilterModelChange: onFilterModelChange, "columnHeader--showColumnBorder": false, initialState: {
                            pagination: {
                                paginationModel: {
                                    pageSize: AppConsts.GRID_DEFAULT_PAGE_SIZE,
                                },
                            },
                        }, pageSizeOptions: [AppConsts.GRID_DEFAULT_PAGE_SIZE], disableRowSelectionOnClick: true, hideFooterPagination: !subGoalList?.length, slots: { noRowsOverlay: WnNoRecordFound }, sx: { "--DataGrid-overlayHeight": "300px" }, columnVisibilityModel: {
                            isActive: hasEditPermission ?? true,
                        } }, "goal-grid") }) })] }));
};
export default SubGoalsList;
